"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fields_1 = require("../../fields/fields");
const botones_1 = require("../../botones");
const formfield_1 = require("../../formfield");
const rango_1 = require("./rango");
function filter(item, data) {
    const min = data.inicio;
    const max = data.final;
    const itemValue = item && item.valueOf && item.valueOf() || undefined;
    const itemValueNumber = typeof itemValue == "number" && itemValue || undefined;
    return rango_1.busquedaRango(min && min.valueOf(), max && max.valueOf(), itemValueNumber);
}
function FiltroRangoFechasComponent(props) {
    const x = props.value || {};
    const getField = formfield_1.formfields(() => props);
    const DateTime2 = getField(fields_1.DateTime);
    return (React.createElement("div", null,
        React.createElement("div", { className: "col-md-6" },
            React.createElement(DateTime2, { field: "inicio", label: React.createElement("span", null,
                    React.createElement(botones_1.Link, { iconClass: "fa fa-times", onClick: props.onQuitar }),
                    " ",
                    React.createElement("label", null, props.titulo + " inicio")) })),
        React.createElement("div", { className: "col-md-6" },
            React.createElement(DateTime2, { field: "final", label: props.titulo + " final" }))));
}
/**Filtro ppr rango de fechas */
exports.filtro = {
    component: FiltroRangoFechasComponent,
    filter: (item, data) => filter(item, data)
};



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/rangoFechas.js
// module id = 506
// module chunks = 0